// Auto-generated skeleton for AccountName

export const AccountName: Api.AccountName = {
  id: 0,
  hp_id: null,
  name: '',
  created: null,
  updated: null,
};

